<template>
  <div class="investmentReport">
    <h1 class="px-2">{{ reportDetails.Title }}</h1>

    <v-row no-gutters>
      <v-col cols="12" sm="8">
        <v-card class="pa-2" outlined tile>
          <v-data-table
            :headers="tableHeaders"
            :items="reportData"
            :loading="loading"
            :items-per-page="-1"
          >
            <template v-slot:loading>
              <v-progress-circular
                indeterminate
                :size="50"
                color="blue lighten-5"
                class="my-4"
              ></v-progress-circular>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'InvestmentReport',

  props: {
    reportId: { type: Number, required: true },
    investRunId: { type: String, required: true },
  },

  data() {
    return {
      loading: false,
      reportData: [],
      reportDetails: {},
    };
  },

  mounted() {
    this.loading = true;
    this.getReportDetails();
  },

  computed: {
    tableHeaders() {
      if (!this.reportData.length) return [];
      return Object.keys(this.reportData[0]).map((key) => ({
        text: key,
        value: key,
      }));
    },
  },

  methods: {
    async getReportDetails() {
      try {
        let response = await this.$api.get(`/invest/getreportheadbyid?reportId=${this.reportId}`);

        this.reportDetails = response.data;

        this.getReportData();
      } catch (err) {
        console.error(err);
      }
    },

    async getReportData() {
      try {
        let response = await this.$api.get(
          `/invest/getreportdatabyid?reportId=${this.reportId}&investRunId=${this.investRunId}`
        );

        this.reportData = response.data;

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.error(err);
      }
    },
  },
};
</script>
